import {Injectable} from "@angular/core";
import {Observable, Subscriber} from "rxjs";
import {PaymentRow} from "../types/paymentrow";
import {ConfigurationService} from "./configuration";
import {CardPayment} from "../types/cardPayment";
import {CardPaymentServiceNets} from "./cardpayment.service.nets";
import {Receipt} from "../types/receipt";
import {CardPaymentAndPrintServicePoplatek} from "./cardpayment.service.poplatek";

@Injectable()
export class CardPaymentService implements CardPayment {

  currentStrategy: CardPayment;

  constructor(private conf: ConfigurationService,
              private nets: CardPaymentServiceNets,
              private poplatekWs: CardPaymentAndPrintServicePoplatek) {
    this.checkStrategy();
  }

  public pay(receipt: Receipt, paymentLine): Observable<PaymentRow> {
    return this.currentStrategy.pay(receipt, paymentLine);
  }

  public refund(receipt, paymentLine): Observable<PaymentRow> {
    return this.currentStrategy.refund(receipt, paymentLine);
  }

  public endOfDayReconciliation(day: Date): Observable<any> {
    return this.currentStrategy.endOfDayReconciliation(day);
  }

  getId(): string {
    return this.currentStrategy.getId();
  }

  init(): void {
    this.currentStrategy.init();
  }

  public checkStrategy() {
    if (this.conf.isPoplatekWsPt()) {
      this.currentStrategy = this.poplatekWs;
    } else {
      this.currentStrategy = this.nets;
    }
  }

  getStatus(): Observable<string> {
    return this.currentStrategy.getStatus();
  }

  abortPayment(receipt: Receipt): Observable<Receipt> {
    return this.currentStrategy.abortPayment(receipt);
  }

  getPosMessage():  Observable<string> {
    return this.currentStrategy.getPosMessage();
  }
}
